import { AlertCircle, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonation();
  const navigate = useNavigate();
  const { toast } = useToast();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
      toast({
        title: 'Impersonation ended',
        description: 'You are now viewing as yourself',
      });
      navigate('/admin');
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to stop impersonation',
        variant: 'destructive',
      });
    }
  };

  return (
    <div className="bg-red-600 text-white py-3 px-4 shadow-lg sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertCircle className="h-5 w-5 flex-shrink-0" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
            <span className="font-semibold">Impersonating:</span>
            <span className="font-normal">
              {impersonatedUser.name} ({impersonatedUser.email})
            </span>
          </div>
        </div>
        <Button
          onClick={handleStopImpersonation}
          variant="outline"
          size="sm"
          className="bg-white text-red-600 hover:bg-red-50 hover:text-red-700 border-white flex items-center gap-2"
        >
          <X className="h-4 w-4" />
          <span className="hidden sm:inline">Exit Impersonation</span>
          <span className="sm:hidden">Exit</span>
        </Button>
      </div>
    </div>
  );
}
